// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetVacuumAdvisorBloatDataQueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
  databaseId?: Types.InputMaybe<Types.Scalars["ID"]["input"]>;
}>;

export type GetVacuumAdvisorBloatDataQuery = {
  __typename?: "GraphqlQuery";
  getSchemaTableListWithVacuumSettings: Array<{
    __typename?: "SchemaTableListWithVacuumSettings";
    id: string;
    databaseId: string;
    databaseName: string;
    tableId: string;
    schemaName: string;
    tableName: string;
    sizeBytes?: number | null;
    lastVacuumAt?: number | null;
    lastAutovacuumAt?: number | null;
    estimatedTableBytes?: number | null;
    idealTableBytes?: number | null;
    tableAutovacuumVacuumThreshold?: number | null;
    tableAutovacuumVacuumScaleFactor?: number | null;
    serverAutovacuumVacuumThreshold?: number | null;
    serverAutovacuumVacuumScaleFactor?: number | null;
  }>;
  getCheckConfig: {
    __typename?: "CheckConfig";
    id: string;
    enabled: boolean;
    settings: any;
  };
};

export const GetVacuumAdvisorBloatDataDocument = gql`
  query GetVacuumAdvisorBloatData($serverId: ID!, $databaseId: ID) {
    getSchemaTableListWithVacuumSettings(
      serverId: $serverId
      databaseId: $databaseId
    ) {
      id
      databaseId
      databaseName
      tableId
      schemaName
      tableName
      sizeBytes
      lastVacuumAt
      lastAutovacuumAt
      estimatedTableBytes
      idealTableBytes
      tableAutovacuumVacuumThreshold
      tableAutovacuumVacuumScaleFactor
      serverAutovacuumVacuumThreshold
      serverAutovacuumVacuumScaleFactor
    }
    getCheckConfig(
      serverId: $serverId
      checkGroupAndName: "vacuum/xmin_horizon"
    ) {
      id
      enabled
      settings
    }
  }
`;

/**
 * __useGetVacuumAdvisorBloatDataQuery__
 *
 * To run a query within a React component, call `useGetVacuumAdvisorBloatDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVacuumAdvisorBloatDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVacuumAdvisorBloatDataQuery({
 *   variables: {
 *      serverId: // value for 'serverId'
 *      databaseId: // value for 'databaseId'
 *   },
 * });
 */
export function useGetVacuumAdvisorBloatDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetVacuumAdvisorBloatDataQuery,
    GetVacuumAdvisorBloatDataQueryVariables
  > &
    (
      | { variables: GetVacuumAdvisorBloatDataQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetVacuumAdvisorBloatDataQuery,
    GetVacuumAdvisorBloatDataQueryVariables
  >(GetVacuumAdvisorBloatDataDocument, options);
}
export function useGetVacuumAdvisorBloatDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetVacuumAdvisorBloatDataQuery,
    GetVacuumAdvisorBloatDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetVacuumAdvisorBloatDataQuery,
    GetVacuumAdvisorBloatDataQueryVariables
  >(GetVacuumAdvisorBloatDataDocument, options);
}
// @ts-ignore
export function useGetVacuumAdvisorBloatDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetVacuumAdvisorBloatDataQuery,
    GetVacuumAdvisorBloatDataQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetVacuumAdvisorBloatDataQuery,
  GetVacuumAdvisorBloatDataQueryVariables
>;
export function useGetVacuumAdvisorBloatDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetVacuumAdvisorBloatDataQuery,
        GetVacuumAdvisorBloatDataQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetVacuumAdvisorBloatDataQuery | undefined,
  GetVacuumAdvisorBloatDataQueryVariables
>;
export function useGetVacuumAdvisorBloatDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetVacuumAdvisorBloatDataQuery,
        GetVacuumAdvisorBloatDataQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetVacuumAdvisorBloatDataQuery,
    GetVacuumAdvisorBloatDataQueryVariables
  >(GetVacuumAdvisorBloatDataDocument, options);
}
export type GetVacuumAdvisorBloatDataQueryHookResult = ReturnType<
  typeof useGetVacuumAdvisorBloatDataQuery
>;
export type GetVacuumAdvisorBloatDataLazyQueryHookResult = ReturnType<
  typeof useGetVacuumAdvisorBloatDataLazyQuery
>;
export type GetVacuumAdvisorBloatDataSuspenseQueryHookResult = ReturnType<
  typeof useGetVacuumAdvisorBloatDataSuspenseQuery
>;
export type GetVacuumAdvisorBloatDataQueryResult = Apollo.QueryResult<
  GetVacuumAdvisorBloatDataQuery,
  GetVacuumAdvisorBloatDataQueryVariables
>;
